import React from 'react';
import { Box, Button, Dialog, Divider, Grid, IconButton, Typography } from '@mui/material';
import { styled as materialStyled } from '@mui/material/styles';
import CloseSvg from '../../../assets/img/close-icon-blue.svg';
import { GemColor } from '../../../utils/enums/gem-color.enum';
import { theme } from '../../../theme/theme';
import CushionSvg from '../../../assets/img/cushion.svg';
import EmeraldSvg from '../../../assets/img/emerald.svg';
import HeartSvg from '../../../assets/img/heart.svg';
import HexagonalSvg from '../../../assets/img/hexagonal.svg';
import KiteSvg from '../../../assets/img/kite.svg';
import MarquiseSvg from '../../../assets/img/mariquise.svg';
import OctagonalSvg from '../../../assets/img/octagonal.svg';
import OtherSvg from '../../../assets/img/other.svg';
import OvalSvg from '../../../assets/img/oval.svg';
import PearSvg from '../../../assets/img/pear.svg';
import RadiantSvg from '../../../assets/img/radiant.svg';
import RoundSvg from '../../../assets/img/round.svg';
import SquareSvg from '../../../assets/img/suqare.svg';
import TriangularSvg from '../../../assets/img/triangular.svg';
import TriliantSvg from '../../../assets/img/trilliant.svg';
import { GemShape } from '../../../utils/enums/gem-shape.enum';

interface ColorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectShape: (_shape: GemShape) => void;
}

const CustomButton = materialStyled(Button)(() => ({
  borderRadius: '8px',
  padding: '4px 8px',
  textAlign: 'center',
  textTransform: 'none',
  fontFamily: 'Satoshi',
  fontSize: 15,
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: 'normal',
  height: '28px',
  color: theme.palette.black.main,
  border: `1px solid ${theme.palette.shades.whiteBorder2}`,
  backgroundColor: 'transparent',
  '&:hover': {
    color: theme.palette.black.main,
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.shades.primaryBrightDark}`,
  },
}));

const shapes = [
  {
    icon: OvalSvg,
    name: GemShape.Oval,
  },
  {
    icon: RoundSvg,
    name: GemShape.Round,
  },
  {
    icon: EmeraldSvg,
    name: GemShape.Emerald,
  },
  {
    icon: PearSvg,
    name: GemShape.Pear,
  },
  {
    icon: OctagonalSvg,
    name: GemShape.Octagonal,
  },
  {
    icon: SquareSvg,
    name: GemShape.Square,
  },
  {
    icon: MarquiseSvg,
    name: GemShape.Marquise,
  },
  {
    icon: HeartSvg,
    name: GemShape.Heart,
  },
  {
    icon: TriangularSvg,
    name: GemShape.Triangular,
  },
  {
    icon: RadiantSvg,
    name: GemShape.Radiant,
  },
  {
    icon: KiteSvg,
    name: GemShape.Kite,
  },
  {
    icon: CushionSvg,
    name: GemShape.Cushion,
  },
  {
    icon: TriliantSvg,
    name: GemShape.Trilliant,
  },
  {
    icon: HexagonalSvg,
    name: GemShape.Hexagonal,
  },
  {
    icon: OtherSvg,
    name: GemShape.Other,
  },
];

const SelectShapeModal: React.FC<ColorModalProps> = ({ isOpen, onClose, onSelectShape }) => {
  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} PaperProps={{ sx: { borderRadius: '12px', maxWidth: '725px' } }} fullWidth>
      <Box sx={{ overflow: 'auto' }}>
        <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}>
          <Typography variant="textBaseLg500">Select Shape</Typography>
          <IconButton>
            <Box data-testid="close-button" component="img" src={CloseSvg} onClick={onClose} />
          </IconButton>
        </Box>
        <Divider orientation="horizontal" flexItem />
        <Box
          sx={{
            p: 2,
          }}
        >
          {shapes.map((shape) => (
            <CustomButton
              key={shape.name}
              variant="outlined"
              onClick={() => {
                onSelectShape(shape.name);
                onClose();
              }}
              sx={{ width: '107px', height: '88px', margin: 0.5 }}
            >
              <Grid display="flex" flexDirection="column" gap={1.5}>
                <Box component="img" src={shape.icon} height={40} />

                <Typography variant="textBase500">{shape.name}</Typography>
              </Grid>
            </CustomButton>
          ))}
        </Box>
      </Box>
    </Dialog>
  );
};

export default SelectShapeModal;
